import React, {useContext} from 'react';
import PingAuthProperties from './types/PingAuthProperties';
import {usePingAuth} from './usePingAuth';
import PingAuthContextProps, {emptyPingAuthContext} from './types/PingAuthContextProps';
import {PING_APPLICATION_ID, PING_CALLBACK_DOMAIN, PING_LOGIN_URL} from '~/utils/Constants';

const PingAuthContext = React.createContext<PingAuthContextProps>(emptyPingAuthContext);

export const PingAuthProvider = ({children}) => {
    const loginUrl = PING_LOGIN_URL;
    const callbackDomain = PING_CALLBACK_DOMAIN;
    const applicationId = PING_APPLICATION_ID;
    const authProperties: PingAuthProperties = {
        applicationId,
        callbackDomain,
        loginUrl,
    };
    const contextProperties: PingAuthContextProps = usePingAuth(authProperties);

    return (
        <PingAuthContext.Provider value={contextProperties}>{children}</PingAuthContext.Provider>
    );
};

export const usePingAuthContext = (): PingAuthContextProps => {
    return useContext<PingAuthContextProps>(PingAuthContext);
};
